export const reportUnitPerformanceTypes = {
  SET_UNIT_PERFORMANCE_FILTERS: 'SET_UNIT_PERFORMANCE_FILTERS',
  RESTORE_INITIAL: 'REPORT_UNIT_PERFORMANCE/RESTORE_INITIAL'
};
